import React, { useState } from 'react';
import { MemberType } from '../../types';
import { AddMemberByCsv } from './AddMemberByCsv/component';
import { AddMemberByEmail } from './AddMemberByEmail/component';
import { Header } from './styles';

export interface AddMemberProps {
  memberType: MemberType;
  currentInstitutionPath: string;
}

export const AddMember: React.FC<AddMemberProps> = ({
  memberType,
  currentInstitutionPath,
}) => {
  const [
    selectedAddTeamMemberOption,
    setSelectedAddTeamMemberOption,
  ] = useState<'' | 'email' | 'csv'>('');

  const onCancelModeClicked = (): void => setSelectedAddTeamMemberOption('');

  return (
    <>
      <Header>Add {memberType}</Header>
      {selectedAddTeamMemberOption !== 'csv' && (
        <AddMemberByEmail
          memberType={memberType}
          institutionPath={currentInstitutionPath}
          onCancelClicked={onCancelModeClicked}
          onEmailListModeChosen={() => setSelectedAddTeamMemberOption('email')}
        />
      )}
      {selectedAddTeamMemberOption !== 'email' && (
        <AddMemberByCsv
          memberType={memberType}
          institutionPath={currentInstitutionPath}
          onCancelClicked={onCancelModeClicked}
          onCsvModeChosen={() => setSelectedAddTeamMemberOption('csv')}
        />
      )}
    </>
  );
};
